import React, {  } from 'react';
import SeriiBlock from '../../components/SeriiBlock'
import PageLayout from '../../components/PageLayout';

export default function FederationadministratorEventsSerii(props) {
    // const context = React.useMemo(() => ({
    //     mix: (item) => {
    //         return {
    //             organizatorFederatsiyaID: 1, // Организатор федерация
    //         }
    //     }
    // }), [])

    return (
        <PageLayout>
        <SeriiBlock auth={props.auth} source={"/api/serii/list/fed"}
                base="federation-administrator" 
                sourceKey="fed"
                create={true}
                ctx={{organizatorFederatsiyaID: 1}}
            />
            </PageLayout>
    );
}
